<!--
	ReferralUpdateBanner.svelte

    Similar to PageBanner but styled differently and has sub-text beneath title.
    Hard coded to display "Connect" and the molecular graphic.
-->

<script>
    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
	// import { Icon } from '@smui/icon-button';
	// import { Svg } from '@smui/common/elements';
	// import { mdiArrowLeftCircle } from '@mdi/js';
    // import { pop } from 'svelte-spa-router';

    const SVG_CONNECT_PATH = '/svg-icons/button-icons/molecular-ruby.svg';
    
    // layout the questions using a data structure
    const questionSet = {};


    onMount(() => {
    })

</script>

<style>
    .referral-banner {
        width: 98%;
        padding: 10px 1% 10px 0%;
        margin: 20px 0px;
        color: var(--tcui-secondary);
    }

    /*
    .referral-banner .back-icon {
        width: 36px;
        height: 36px;
        margin-right: 10px;
    }

    .referral-banner .back-icon:hover {
        transform: scale(1.2);
    }
    */

    :global(.referral-banner .back-icon svg) {
        fill: var(--tcui-secondary);
        transition: all .2s;
    }

    :global(.referral-banner .back-icon svg:hover) {
        fill: var(--tcui-primary);
        transform: scale(1.1);
    }

    .referral-banner .banner-title {
        font-size: 28px;
        font-weight: 400;
        margin-right: 10px;
    }

    .referral-banner .banner-icon {
        margin-top: 20px;
    }

    .referral-banner .banner-text {
        margin-top: -10px;
        font-size: 14px;
        font-weight: 500;
        color: var(--tcui-primary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<div class="referral-banner"> 
    <div class="flex-row jc-start fs-2 fw-100">
        <!--
        <div class="back-icon" on:click={() => pop()}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowLeftCircle} /></Icon>	
        </div>
        -->
        <div class="banner-title">
            Referral Update
        </div>
        <div class="banner-icon">
            <img src={SVG_CONNECT_PATH} alt={'Connect'} draggable='false'>
        </div>
    </div>
    <div class="flex-row jc-start banner-text">
        You previously connected with this service. 
        Please fill out the questions below about your interactions with the service to recieve better suited in the future.
    </div>

</div>
